var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2192 5.52508L6.62417 10.1201C6.06125 10.683 5.29776 10.9992 4.50167 10.9992C3.70558 10.9992 2.94209 10.683 2.37917 10.1201C1.81625 9.55716 1.5 8.79367 1.5 7.99758C1.5 7.20149 1.81625 6.438 2.37917 5.87508L6.66417 1.59008C7.03945 1.21413 7.5487 1.00267 8.0799 1.0022C8.6111 1.00173 9.12072 1.2123 9.49667 1.58758C9.87261 1.96286 10.0841 2.47211 10.0845 3.00331C10.085 3.53451 9.87445 4.04413 9.49917 4.42008L5.20417 8.70508C5.01653 8.89272 4.76203 8.99813 4.49667 8.99813C4.2313 8.99813 3.97681 8.89272 3.78917 8.70508C3.60153 8.51744 3.49611 8.26294 3.49611 7.99758C3.49611 7.73221 3.60153 7.47772 3.78917 7.29008L8.03417 3.05008",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.23541fa328102b0fb2254e7eac6cfe75.svg";
export { ForwardRef as ReactComponent };